<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://greenbox.tw/"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            無毒農
          </a>
        </li>
        <li class="nav-item">
          <a
            href="https://greenbox.tw/Home/AboutNew"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            關於我們
          </a>
        </li>
        <li class="nav-item">
          <a
            href="https://www.facebook.com/GreenBox.in.tw"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            <i class="fab fa-facebook"></i>無毒農-友善環境的安心水果
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }}, made with <i class="tim-icons icon-heart-2"></i> by
        <a
          href="https://www.creative-tim.com/?ref=vbdp-vuejs"
          target="_blank"
          rel="noopener"
          >Creative Tim</a
        >
        for a better web.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
